// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
const { pluralize } = require('shared/string-utils')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { eventHandler } = require('client-v2/common/utils/events')
const UserAvatar = require('client-v2/common/components/user-avatar')
const { collectionProfileHref } = require('client-v2/common/models/collection/actions')
const { userProfileHref } = require('client-v2/common/models/user/actions')

// String helpers
const followers = pluralize('follower')

// BEM Block entity definition
const bem = BemEntity('ArticleProfileCollectionsItem')

function ArticleProfileCollectionsItem(props) {
  const { user } = props.item
  const followerCount = user['follower_count'] || 0
  const onUserClick = eventHandler(props.onUserNavigate, { user })

  return (
    tag('section', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(UserAvatar, {
        className: bem.element('user-icon'),
        href: true,
        user,
        onClick: onUserClick
      }),

      tag('a', {
        className: bem.element('user-href'),
        href: userProfileHref(user),
        onClick: onUserClick
      },
        `@${user.username}`
      ),

      tag('div', {
        className: bem.element('follower-count')
      },
        followerCount.toLocaleString(),
        ' ',
        followers(followerCount)
      ),

      tag(CollectionsList, {
        item: props.item,
        onCollectionNavigate: props.onCollectionNavigate
      })
    )
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  ArticleProfileCollectionsItem.propTypes = {
    // Values
    className: PropTypes.string,
    item: PropTypes.object.isRequired,
    // Callbacks
    onCollectionNavigate: PropTypes.func.isRequired,
    onUserNavigate: PropTypes.func.isRequired
  }
}

module.exports = ArticleProfileCollectionsItem

// BEM Block entity Element components

function CollectionsList(props) {
  const { collections } = props.item
  if (!collections || !collections.length) {
    return (
      tag('div', {
        className: bem.element('collections', 'mixed')
      })
    )
  }
  return (
    tag('div', {
      className: bem.element('collections')
    },
      'Added to ',
      tag(CollectionsText, {
        collections,
        maxCollectionsLength: 5, // Response limit of getUrlMixHistoryV2
        onCollectionNavigate: props.onCollectionNavigate
      })
    )
  )
}

function CollectionHref(props) {
  const { collection } = props
  if (!collection) {
    return null
  }
  return (
    tag('a', {
      className: bem.element('collection-href'),
      href: collectionProfileHref(collection),
      onClick: eventHandler(props.onCollectionNavigate, { collection })
    },
      collection.name
    )
  )
}

function CollectionsText(props) {
  const [ isExpanded, setExpanded ] = React.useState(false)
  const { collections, onCollectionNavigate } = props
  if (!collections || !collections.length) {
    return null
  }
  const [ first, ...rest ] = collections // None for Mixed collections
  const restLimit = props.maxCollectionsLength - 1 // Minus the first one
  if (!rest.length) {
    return (
      tag(CollectionHref, {
        collection: first,
        onCollectionNavigate
      })
    )
  }
  if (!isExpanded) {
    return tag([
      tag(CollectionHref, {
        collection: first,
        onCollectionNavigate
      }),
      ' and ',
      tag('button', {
        className: bem.element('collections-expand'),
        onClick: () => setExpanded(true)
      },
        rest.length < restLimit
        ? `${rest.length} more`
        : 'more'
      )
    ])
  }
  return tag([
    tag(CollectionHref, {
      collection: first,
      onCollectionNavigate
    }),
    ...rest.map((collection, index) => {
      const isLastIndex = index === rest.length - 1
      const hasLeadingComma = rest.length > 1
      const hasLeadingAnd = rest.length < restLimit && isLastIndex
      const hasTrailingAndMore = rest.length >= restLimit && isLastIndex
      return (
        tag([
          hasLeadingComma && ',',
          ' ',
          hasLeadingAnd && 'and ',
          tag(CollectionHref, {
            collection,
            onCollectionNavigate
          }),
          hasTrailingAndMore && ', and more'
        ])
      )
    })
  ])
}
